import type { CSSProperties } from 'react';

import classNames from 'classnames';

import SimpleModal from '@/ui/SimpleModal';

import { ButtonElement } from '../shared/buttonElement/ButtonElement';
import { LoaderElement } from '../shared/loaderElement/LoaderElement';
import { confirmActionModalContent } from './ConfirmActionModalElement.css';
import type { ConfirmActionModalElementProps } from './ConfirmActionModalElement.types';

export function ConfirmActionModalElement({
  isOpen,
  onOpenChange,
  onCancel,
  onSubmit,
  isSubmitting,
  title,
  message,
  cancelLabel,
  submitLabel,
  submitVariant = 'primary',
  isLoading,
}: ConfirmActionModalElementProps) {
  const generatedStyle = {
    '--overlay-background-color': '#00000030',
    '--modal-close-button-color': undefined,
    '--modal-close-button-placement-top': '24px',
    '--modal-close-button-placement-right': '24px',
  } as CSSProperties;

  return (
    <SimpleModal
      isOpen={isOpen}
      onClose={onOpenChange}
      className="overflow-hidden shadow-lg sm:rounded-md"
      style={generatedStyle}
      showCloseButton={false}
      showRoundedBorders={false}
      shouldCloseOnOutsideClick={false}
      shouldDisableScroll={false}
    >
      <div className={classNames(confirmActionModalContent, 'w-full sm:w-[460px]')}>
        <div className="flex flex-col w-full gap-1">
          <h1 className="w-full text-lg font-bold leading-7 text-gray-900">{title}</h1>
          {isLoading ? (
            <LoaderElement count={2} heightClassName="h-4" />
          ) : (
            message && <p className="w-full text-sm font-normal leading-5 text-gray-500">{message}</p>
          )}
        </div>
        <div className="flex justify-end gap-2 mt-4">
          <ButtonElement variant="default" disabled={isSubmitting} type="button" onClick={onCancel}>
            {cancelLabel}
          </ButtonElement>
          <ButtonElement
            disabled={!!isLoading}
            variant={submitVariant}
            isSubmitting={isSubmitting}
            type="button"
            onClick={onSubmit}
          >
            {submitLabel}
          </ButtonElement>
        </div>
      </div>
    </SimpleModal>
  );
}
